import { render, staticRenderFns } from "./u-mobile-nav-head-basic.vue?vue&type=template&id=f1fdfba4&scoped=true&"
import script from "./u-mobile-nav-head-basic.vue?vue&type=script&lang=js&"
export * from "./u-mobile-nav-head-basic.vue?vue&type=script&lang=js&"
import style0 from "./u-mobile-nav-head-basic.vue?vue&type=style&index=0&id=f1fdfba4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1fdfba4",
  null
  
)

export default component.exports